import { render, staticRenderFns } from "./addnew.vue?vue&type=template&id=066f227e&scoped=true&"
import script from "./addnew.vue?vue&type=script&lang=js&"
export * from "./addnew.vue?vue&type=script&lang=js&"
import style0 from "./addnew.vue?vue&type=style&index=0&id=066f227e&prod&lang=scss&"
import style1 from "./addnew.vue?vue&type=style&index=1&id=066f227e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "066f227e",
  null
  
)

export default component.exports